<template>
  <kt-panel>
    <div class="accordion accordion-toggle-arrow" id="userFilter">
      <div class="card" style="overflow:inherit">
        <div class="card-header bg-transparent" id="headingOne">
          <div class="card-title collapsed" data-toggle="collapse"
               data-target="#filterForm"
               aria-controls="filterForm">
            {{ $t('label.search') }}
          </div>
        </div>
        <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#userFilter">
          <div class="card-body">
            <form @submit.prevent="action($event, query)" :id="'open-banking-bankito-filter-form-' + form_id">
              <kt-form-section>
                <kt-form-row>
                  <kt-col xs="12" sm="6" md="3">
                    <kt-form-group>
                      <kt-form-label for="user_full_name">
                        {{ $t('label.user_full_name') }}
                      </kt-form-label>
                      <kt-form-control
                          ref="user_full_name"
                          dir="rtl"
                          name="user_full_name"
                          id="user_full_name"
                          v-model="query.user_full_name"
                      />
                    </kt-form-group>
                  </kt-col>
                  <kt-col xs="12" sm="6" md="3">
                    <kt-form-group>
                      <kt-form-label for="application_title">
                        {{ $t('application.title') }}
                      </kt-form-label>
                      <kt-form-control
                          ref="application_title"
                          dir="ltr"
                          name="application_title"
                          id="application_title"
                          v-model="query.application_title"
                      />
                    </kt-form-group>
                  </kt-col>
                  <kt-col xs="12" sm="6" md="3">
                    <kt-form-group>
                      <kt-form-label for="amount">
                        {{ `${$t('label.amount')} (${$t('wallets.label.rial')})` }}
                      </kt-form-label>
                      <kt-form-control
                          ref="amount"
                          dir="ltr"
                          name="amount"
                          id="amount"
                          v-model="query.amount"
                      />
                    </kt-form-group>
                  </kt-col>
                  <kt-col xs="12" sm="6" md="3">
                    <kt-form-group>
                      <kt-form-label for="status">
                        {{ $t('open_banking.request_status') }}
                      </kt-form-label>
                      <kt-form-select
                          size="3"
                          id="status"
                          class="form-control"
                          name="status"
                          v-model="query.status"
                      >
                        <option value=""></option>
                        <option
                            v-bind:key="request_status"
                            v-for="request_status in bankTransferTransaction"
                            v-bind:value="request_status"
                            :selected="query.status === request_status"
                        >
                          {{ bankTransferTransactionStr.get(request_status) }}
                        </option>
                      </kt-form-select>
                    </kt-form-group>
                  </kt-col>
                  <kt-col   xs="12" sm="6" md="3">
                    <kt-form-group>
                      <kt-form-label for="provider">
                        {{ `${$t('label.track_id')}  ${$t('label.acceptor')}` }}
                      </kt-form-label>
                      <input id="track_id" v-model="query.track_id" class="form-control">
                    </kt-form-group>
                  </kt-col>
                  <kt-col xs="12" sm="6" md="3">
                    <kt-form-group>
                      <kt-form-label for="status">
                        {{ $t('transaction_transfer.origin_account') }}
                      </kt-form-label>
                      <input id="track_id" v-model="query.origin_account" class="form-control">

                    </kt-form-group>
                  </kt-col>
                  <kt-col xs="12" sm="6" md="3">
                    <kt-form-group>
                      <kt-form-label for="status">
                        {{ $t('transaction_transfer.destination_account') }}
                      </kt-form-label>
                      <input id="track_id" v-model="query.destination_account" class="form-control">

                    </kt-form-group>
                  </kt-col>
                  <kt-col xs="12" sm="6" md="3">
                    <kt-form-group>
                      <kt-form-label for="provider">
                        {{ $t('pos.bank') }}
                      </kt-form-label>
                      <kt-form-select
                          size="3"
                          id="provider"
                          class="form-control"
                          name="provider"
                          v-model="query.bank"
                      >
                        <option value=""></option>
                        <option
                            v-bind:key="bank"
                            v-for="bank in bankId"
                            v-bind:value="bank"
                        >
                          {{ bankIdStr.get(bank) }}
                        </option>
                      </kt-form-select>
                    </kt-form-group>
                  </kt-col>
                  <kt-col xs="12" sm="3" md="3" class="mb-2">
                    <label for="service_type"
                           v-text="$t('open_banking.service_type')"
                    >
                    </label>
                    <select id="service_type"
                            class="form-control"
                            v-model="query.service_type"
                    >
                      <option :value="null"></option>
                      <option v-for="(item, index) in bankTransferTransactionServiceType" :key="index" v-text="bankTransferTransactionServiceTypeStr.get(item)" :value="item"></option>
                    </select>
                  </kt-col>
                  <kt-col xs="12" sm="3" md="3">
                    <kt-form-group>
                      <kt-form-label for="from_date">
                        {{ $t('label.from_date') }}
                      </kt-form-label>
                      <button id="reset_from_date"
                              @click="clearFromDate"
                              class=" btn btn-label-danger trash-btn"
                              type="button"
                      >
                        <i class="la la-trash-o"></i>
                      </button>
                      <datePicker
                          format="YYYY-MM-DD HH:mm:ss"
                          display-format="dddd jDD jMMMM jYYYY HH:mm"
                          type="datetime"
                          input-class="form-control"
                          id="from_date"
                          name="from_date"
                          v-model="query.from_date"/>
                    </kt-form-group>
                  </kt-col>
                  <kt-col xs="12" sm="3" md="3">
                    <kt-form-group>
                      <kt-form-label for="to_date">
                        {{ $t('label.to_date') }}
                      </kt-form-label>
                      <button id="reset_to_date"
                              @click="clearToDate"
                              class=" btn btn-label-danger trash-btn"
                              type="button"
                      >
                        <i class="la la-trash-o"></i>
                      </button>
                      <datePicker
                          format="YYYY-MM-DD HH:mm:ss"
                          display-format="dddd jDD jMMMM jYYYY HH:mm"
                          type="datetime"
                          input-class="form-control"
                          id="to_date"
                          name="to_date"
                          v-model="query.to_date"
                      />
                    </kt-form-group>
                  </kt-col>
                  <kt-col xs="12" sm="3" md="3" class="mb-2">
                    <label for="detected_type"
                           v-text="$t('label.detected_type')"
                    >
                    </label>
                    <select id="detected_type"
                            class="form-control"
                            v-model="query.detected_type"
                    >
                      <option :value="null"></option>
                      <option v-text="$t('label.reversed_automatically')" value="0"></option>
                      <option v-text="$t('label.reversed_by_admin')" value="1"></option>
                    </select>
                  </kt-col>
                    <kt-col xs="12" sm="3" md="3" class="mb-2">
                        <label for="service_type"
                               v-text="$t('open_banking.transaction_type')"
                        >
                        </label>
                        <kt-form-select
                            id="transaction_type"
                            class="form-control"
                            v-model="query.transaction_type"
                        >
                            <option :value="null"></option>
                            <option v-for="(item, index) in transactionType" :key="index" v-text="transactionTypeStr.get(item)" :value="item"></option>
                        </kt-form-select>
                    </kt-col>
                    <kt-col xs="12" sm="3" md="3" class="mb-2">
                        <label for="service_type"
                               v-text="$t('open_banking.transfer_type_str')"
                        >
                        </label>
                        <kt-form-select id="transfer_type"
                                        class="form-control"
                                        v-model="query.transfer_type"
                        >
                            <option :value="null"></option>
                            <option v-text="$t('wallets.label.direct')" value="1"></option>
                            <option v-text="$t('wallets.label.queued')" value="2"></option>
                        </kt-form-select>
                    </kt-col>
                    <kt-col xs="12" sm="3" md="3" class="mb-2">
                        <label for="service_type"
                               v-text="$t('open_banking.type')"
                        >
                        </label>
                        <kt-form-select id="transfer_type"
                                        class="form-control"
                                        v-model="query.type"
                        >
                            <option :value="null"></option>
                            <option v-text="$t('application.services.internal_transfer')" value="1"></option>
                            <option v-text="$t('application.services.paya_transfer')" value="2"></option>
                            <option v-text="$t('application.services.satna_transfer')" value="3"></option>
                        </kt-form-select>
                    </kt-col>
                    <kt-col xs="12" sm="6" md="3">
                        <kt-form-group>
                            <kt-form-label for="from_amount">
                                از مبلغ
                            </kt-form-label>
                            <input id="from_amount" v-model="query.from_amount" class="form-control">

                        </kt-form-group>
                    </kt-col>
                    <kt-col xs="12" sm="6" md="3">
                      <kt-form-group>
                        <kt-form-label for="to_amount">
                          تا مبلغ
                        </kt-form-label>
                        <input id="to_amount" v-model="query.to_amount" class="form-control">

                      </kt-form-group>
                    </kt-col>
                    <kt-col xs="12" sm="6" md="3">
                        <kt-form-group>
                            <kt-form-label for="transaction_type">
                                نوع تراکنش
                            </kt-form-label>
                            <select class="form-control" v-model="query.transaction_type"
                                    id="transaction_type">
                                <option :value="null"></option>
                                <option value="1">داخلی</option>
                                <option value="2">پایا</option>
                                <option value="3">ساتنا</option>
                            </select>
                        </kt-form-group>
                    </kt-col>
                    <kt-col xs="12" sm="6" md="3">
                      <kt-form-group>
                        <kt-form-label for="destination_fullname">
                          نام و نام خانوادگی مقصد
                        </kt-form-label>
                        <input id="destination_fullname" v-model="query.destination_fullname" class="form-control">

                      </kt-form-group>
                    </kt-col>
                    <kt-col xs="12" sm="6" md="3">
                      <kt-form-group>
                        <kt-form-label for="origin_fullname">
                          نام و نام خانوادگی مبدا
                        </kt-form-label>
                        <input id="origin_fullname" v-model="query.origin_fullname" class="form-control">

                      </kt-form-group>
                    </kt-col>
                    <kt-col xs="12" sm="6" md="3">
                      <kt-form-group>
                        <kt-form-label for="pay_id">
                          شناسه واریز
                        </kt-form-label>
                        <input id="pay_id" v-model="query.pay_id" class="form-control">

                      </kt-form-group>
                    </kt-col>
                </kt-form-row>
              </kt-form-section>
              <kt-form-section>
                <input type="submit" class="btn btn-success btn-wide" :value="$t('label.excel_export')">
              </kt-form-section>
              <kt-form-section>
                <kt-row>
                  <kt-col xs="12" sm="6" md="6">
                  </kt-col>
                </kt-row>
              </kt-form-section>
            </form>
          </div>
        </div>
      </div>
    </div>
  </kt-panel>
</template>

<script>
import {
  applicationServiceStatus,applicationServiceStatusStr,openBankingRequestsStatus,
  openBankingRequestsStatusStr,services,providerType,providerTypeStr,
  openBankingTransferDetectedType, openBankingTransferDetectedTypeStr
} from '@/constants/openBanking'
import {userTypes,userTypesStr} from '@/constants/userTypes'
import $ from "jquery";
import {i18n} from '@/plugins/i18n'
import { KTApp } from "@/plugins/core/app";
import axios from "axios";
import {ApiUrl} from '@/common/api.service'
import {
  bankTransferTransactionServiceType,
  bankTransferTransactionServiceTypeStr
} from "@/constants/bankTransferTransactionServiceType";
import {bankId, bankIdStr} from "@/constants/bankId";
import {
    bankTransferTransaction,
    bankTransferTransactionStr,
    transactionType, transactionTypeStr,
} from "@/constants/bankTransferTransaction";

export default {
  computed: {
    bankTransferTransactionServiceTypeStr() {
      return bankTransferTransactionServiceTypeStr
    },
    bankTransferTransactionServiceType() {
      return bankTransferTransactionServiceType
    },
    bankIdStr() {
      return bankIdStr
    },
    bankId() {
      return bankId
    },
    bankTransferTransactionStr() {
      return bankTransferTransactionStr
    },
    bankTransferTransaction() {
      return bankTransferTransaction
    },
      transactionType() {
          return transactionType
      },
      transactionTypeStr() {
          return transactionTypeStr
      },
  },
  props: {
    action: {
      default: function (e, query) {
      },
      required: true,
    },
    form_id: {
      required: true,
      default: '',
    },
  },
  mounted() {
    this.afterDispatch()
  },
  methods: {
    afterDispatch() {
      $('.kt-selectpicker').selectpicker({
        size: 4,
        liveSearch: true,
        noneResultsText: i18n.t('selectpicker.none_result'),
        selectAllText: i18n.t('selectpicker.select_all'),
        noneSelectedText: i18n.t('selectpicker.nothing_selected')
      })
    },
    exportExcel() {
      let btn = $('#open_banking_requests');
      KTApp.progress(btn);

      const payload = {
        query: {
          user_full_name: this.query.user_full_name,
          application_id: this.query.application_id,
          application_title: this.query.application_title,
          provider: this.query.provider,
          status: this.query.status,
          service_type: this.query.service_type,
          from_date: this.query.from_date,
          to_date: this.query.to_date,
          from_amount: this.query.from_amount,
          to_amount: this.query.to_amount,
          transaction_type: this.query.transaction_type,
          type: this.query.type,
          transfer_type: this.query.transfer_type,
          destination_fullname: this.query.destination_fullname,
          origin_fullname: this.query.origin_fullname,
          pay_id: this.query.pay_id,
        }
      };

      let url = '';
      if (this.$can('manage', 'open-banking')) {
        url = `open-banking/requests/admin/export`;
      } else {
        url = `open-banking/requests/common/export`;
      }

      axios({
        url: ApiUrl.path(url),
        method: 'POST',
        data: payload,
        responseType: 'blob',
      }).then((response) => {
        KTApp.unprogress(btn);
        const blob = new Blob([response.data]);
        const fileURL = window.URL.createObjectURL(blob);
        const fileLink = document.createElement('a');

        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'open-banking-requests.xlsx');
        document.body.appendChild(fileLink);

        fileLink.click();
        document.body.removeChild(fileLink);
        window.URL.revokeObjectURL(fileURL);
      }).catch(({ response }) => {
        this.toastr.error(i18n.t('message.an_error_accord'));
        KTApp.unprogress(btn);
      });
    },
    clearFromDate() {
      if(this.query.from_date) {
        this.query.from_date = null
      }
    },
    clearToDate() {
      if(this.query.to_date) {
        this.query.to_date = null
      }
    },
  },
  data() {
    return {
      openBankingRequestsStatus,
      openBankingRequestsStatusStr,
      services,
      query: {
        status: null,
        detected_type: null,
      },
      applicationServiceStatus,
      applicationServiceStatusStr,
      userTypes,
      userTypesStr,
      providerType,
      providerTypeStr,
      openBankingTransferDetectedType,
      openBankingTransferDetectedTypeStr
    }
  }
}
</script>

<style>

</style>